import PopupContainer from './components/PopupContainer';

const Dialog = (): JSX.Element => {
  return <PopupContainer />;
};

export default Dialog;
